import script from "./ControlPanelView.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlPanelView.vue?vue&type=script&setup=true&lang=js"

import "./ControlPanelView.vue?vue&type=style&index=0&id=19ed6986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ed6986"]])

export default __exports__